import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({ selector: '[adsptFormInputStates]' })
export class FormInputStatesDirective implements AfterViewInit {
  constructor(private ele: ElementRef) {}
  addClass(o, c) {
    const re = new RegExp('(^|\\s)' + c + '(\\s|$)', 'g');
    if (re.test(o.className)) {
      return;
    }
    o.className = (o.className + ' ' + c).replace(/\s+/g, ' ');
  }

  removeClass(o, c) {
    const re = new RegExp('(^|\\s)' + c + '(\\s|$)', 'g');
    o.className = o.className
      .replace(re, '$1')
      .replace(/\s+/g, ' ')
      .replace(/(^ | $)/g, '');
  }
  ngAfterViewInit() {
    let ele = this.ele.nativeElement.getElementsByClassName('ant-input')[0];
    if (!ele) {
      ele = this.ele.nativeElement.getElementsByClassName('ant-select-selection-search-input')[0];
    }
    ele.addEventListener('mouseout', () => this.removeClass(this.ele.nativeElement, 'hover'));
    ele.addEventListener('mouseover', () => this.addClass(this.ele.nativeElement, 'hover'));
    ele.addEventListener('focus', () => this.addClass(this.ele.nativeElement, 'focus'));
    ele.addEventListener('blur', () => this.removeClass(this.ele.nativeElement, 'focus'));
  }
}
